import { ResponsiveContainer, AreaChart, CartesianGrid, XAxis, YAxis, Tooltip, Legend, Area } from 'recharts';

interface ComparisonChartProps {
  currentData: Array<{ date: string; amount: number }>;
  previousData: Array<{ date: string; amount: number }>;
}

export const ComparisonChart = ({ currentData, previousData }: ComparisonChartProps) => {
  const combinedData = [
    ...(previousData || []).map(d => ({ ...d, period: 'Mois précédent' })),
    ...(currentData || []).map(d => ({ ...d, period: 'Mois en cours' }))
  ];

  return (
    <ResponsiveContainer width="100%" height="100%">
      <AreaChart data={combinedData}>
        <CartesianGrid strokeDasharray="3 3" stroke="#f1f5f9" />
        <XAxis 
          dataKey="date" 
          stroke="#64748b"
          tick={{ fill: '#64748b', fontSize: 12 }}
          tickLine={{ stroke: '#94a3b8' }}
        />
        <YAxis 
          stroke="#64748b"
          tick={{ fill: '#64748b', fontSize: 12 }}
          tickLine={{ stroke: '#94a3b8' }}
          tickFormatter={(value) => `${value.toLocaleString()} FCFA`}
        />
        <Tooltip 
          contentStyle={{ 
            backgroundColor: '#fff',
            border: '1px solid #e2e8f0',
            borderRadius: '0.5rem',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
          }}
          formatter={(value: number) => [`${value.toLocaleString()} FCFA`, 'Montant']}
        />
        <Legend 
          wrapperStyle={{
            paddingTop: '1rem'
          }}
        />
        <Area 
          type="monotone" 
          dataKey="amount" 
          fill="#3b82f6" 
          stroke="#2563eb"
          name="Ventes"
          fillOpacity={0.2}
          strokeWidth={2}
          dot={{ fill: '#2563eb', stroke: '#2563eb', r: 4 }}
          activeDot={{ r: 6, fill: '#2563eb', stroke: '#fff' }}
        />
      </AreaChart>
    </ResponsiveContainer>
  );
};